export const EARLY_BIRD_SEAT_PRICE = 64
export const REGULAR_SEAT_PRICE = 80
